import styled from 'styled-components'
import Spinner from '../../../assets/icons/spinner.svg?react'
import { rotate } from '../animations/rotate'

export const SmallSpinner = ({ size = 16, inactive }: { size?: number; inactive?: boolean }) => {
  if (inactive) {
    return <InactiveSpinner $size={size} />
  }

  return (
    <Animate $size={size}>
      <Spinner viewBox="0 0 48 48" />
    </Animate>
  )
}

const InactiveSpinner = styled.div<{ $size?: number | undefined }>`
  height: ${({ $size }) => ($size ? `${$size}px` : '16px')};
  width: ${({ $size }) => ($size ? `${$size}px` : '16px')};
  border: 1px solid ${({ theme }) => theme.divider};
  border-radius: 100%;
  box-sizing: border-box;
`

const Animate = styled.div<{ $size?: number | undefined }>`
  animation: ${rotate} 1s infinite linear;
  font-size: 0;
  overflow: visible;

  &,
  svg {
    height: ${({ $size }) => ($size ? `${$size}px` : '16px')};
    width: ${({ $size }) => ($size ? `${$size}px` : '16px')};

    path {
      stroke: ${({ theme }) => theme.primaryMain};
    }
  }
`
